{
    "CallsansweredwithinLabel": "Anrufe sollten beantwortet werden innerhalb von:",
    "CallsansweredwithinPlaceholder": "10",
    "CallsansweredwithinUnit": "s",
    "ServiceLvlSettings_SectionHeader": "Dienstleistungsniveau einstellungen",
    "ServiceLvlSettings_SectionPara": "Sie können die folgenden Einstellungen anpassen, um speziell zu steuern, wie der aktuelle Bericht die Statistik „% Dienstleistungsniveau“ berechnet, wenn sie vom gewählten Berichtsstil unterstützt und auch zur Anzeige ausgewählt wird.",
    "ServiceLvlSettings_IgnorequickabndcallswithinLabel": "Ignorieren Sie schnell abgebrochene Anrufe innerhalb von:",
    "ServiceLvlSettings_IgnorequickabndcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnorequickabndcallswithinEnabledHiddenlabel": "Ist die Einstellung „Schnell aufgegebene Anrufe ignorieren innerhalb“ aktiviert?",
    "ServiceLvlSettings_IgnorequickabndcallswithinUnit": "s",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinLabel": "Übergelaufene Anrufe ignorieren innerhalb:",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinEnabledHiddenlabel": "Ist die Einstellung „Übergelaufene Anrufe innerhalb ignorieren“ aktiviert?",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinUnit": "s",
    "NAME": "ServiceLvlSettings"
}